export default __webpack_public_path__ + "static/100--stacked-area-331aa6e4a810eb1b491773f3c71476ef.png";